import { CookieTokenAuthentication, TokenAuthentication } from '../../authentication';
import { FrontgateWSConnection } from '../FrontgateWSConnection';
export var FetchConnectionConfigurationResponseHeaders;
(function (FetchConnectionConfigurationResponseHeaders) {
    FetchConnectionConfigurationResponseHeaders["FRONTGATE_HOST"] = "frontgate-host";
    FetchConnectionConfigurationResponseHeaders["FRONTGATE_PATH_PREFIX"] = "frontgate-path-prefix";
    FetchConnectionConfigurationResponseHeaders["FRONTGATE_SPLIT_AUTHENTICATION_TOKEN_SECOND_FACTOR"] = "frontgate-split-authentication-token-second-factor";
    FetchConnectionConfigurationResponseHeaders["FRONTGATE_AUTHENTICATION_TYPE"] = "frontgate-authentication-type";
    FetchConnectionConfigurationResponseHeaders["FRONTGATE_AUTHENTICATION_TOKEN"] = "frontgate-authentication-token";
    FetchConnectionConfigurationResponseHeaders["FRONTGATE_WEBSOCKET_PROTOCOL"] = "frontgate-websocket-protocol";
})(FetchConnectionConfigurationResponseHeaders || (FetchConnectionConfigurationResponseHeaders = {}));
export function parseConnectionConfiguration(headers) {
    var config = {};
    var providedHeaders = Object.keys(headers);
    [
        FetchConnectionConfigurationResponseHeaders.FRONTGATE_HOST,
        FetchConnectionConfigurationResponseHeaders.FRONTGATE_PATH_PREFIX,
        FetchConnectionConfigurationResponseHeaders.FRONTGATE_SPLIT_AUTHENTICATION_TOKEN_SECOND_FACTOR,
        FetchConnectionConfigurationResponseHeaders.FRONTGATE_AUTHENTICATION_TYPE,
        FetchConnectionConfigurationResponseHeaders.FRONTGATE_AUTHENTICATION_TOKEN,
        FetchConnectionConfigurationResponseHeaders.FRONTGATE_WEBSOCKET_PROTOCOL
    ].forEach(function (key) {
        if (providedHeaders.indexOf(key) !== -1) {
            config[key.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); })] = headers[key];
        }
    });
    return config;
}
export function objectFromFetchHeaders(providedHeaders) {
    var obj = {};
    providedHeaders.forEach(function (value, key) {
        obj[key] = value;
    });
    return obj;
}
export function fetchConnectionConfiguration(input, init) {
    return fetch(input, init)
        .then(function (response) {
        var headersAsObject = objectFromFetchHeaders(response.headers);
        var config = parseConnectionConfiguration(headersAsObject);
        return [config, response];
    });
}
export function createConnection(options) {
    if (options === void 0) { options = {}; }
    var auth = options.frontgateAuthenticationType === 'token'
        ? new TokenAuthentication(options.frontgateAuthenticationToken)
        : new CookieTokenAuthentication();
    return new FrontgateWSConnection(auth, options);
}
//# sourceMappingURL=connection_functions.js.map